import { defineType } from 'sanity';
import { StaticPageSchema } from '../../objects';
import { HiDocument } from 'react-icons/hi2';

export default defineType({
	name:    'shippingPolicyPage',
	title:   'Shipping Policy Page',
	type:    'document',
	fields:  StaticPageSchema.fields,
	icon:    HiDocument,
	preview: {
		select: {
			title: 'seoTitle',
			slug:  'slug.current',
		},
		prepare({ title, slug }) {
			return {
				title:    title ?? 'Shipping Policy Page',
				subtitle: slug ? `/${slug}` : undefined,
			};
		},
	},
});